<template>
    <tailwind-layout :title="heading">
        <template #header>
            <div class="mb-4 px-4 sm:px-6 lg:px-8 mx-auto flex justify-between items-center">
                <h1 class="font-semibold text-2xl leading-tight">{{ heading }}</h1>
            </div>
        </template>
        <identity-form
            :states="states"
            :attempt="attempt"
            :submit-route="submitRoute"
            :company-name="companyName"
        />
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import IdentityForm from '@/Components/ExperianVerification/IdentityForm.vue'

export default {
    components: {
        TailwindLayout,
        IdentityForm,
    },
    props: {
        states: Object,
        attempt: Object,
        // RAC-10417: the PMC company registration reuses this identity form.
        // Defaults keep the individual verification flow unchanged.
        submitRoute: {
            type: String,
            default: 'experian-verification.store',
        },
        heading: {
            type: String,
            default: 'Get Verified with RentRisk',
        },
        companyName: {
            type: String,
            default: '',
        },
    },
}
</script>
